import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import { getEBLDetails, PartyName,BankName ,getPartyNameList,getBankNameList} from '../actions/eBLActions';

export interface RoleList {
  roleName: string;
  gsbnOrgId: string;
  partyName: string;
  roleId: number;
}

  export interface IEblDetails {
    isEBLDetailsLoading: boolean;
    eblData: {
      blNo: string;
      gsbnAssetId: string;
      pdfUrl: string;
      roleListId: string;
      roleList: RoleList[];
    } | null;
    shipper: string | null;
    titleHolder: string | null;
    consignee: string | null;
    custodian: string | null;
    partyNames: PartyName[] | null;  
    bankNames: BankName[]| null;
  }
  
  const initialState: IEblDetails = {
    isEBLDetailsLoading: false,
    eblData: null,
    shipper: null,
    titleHolder: null,
    consignee: null,
    custodian: null,
    partyNames: [], 
    bankNames:[], 
  };
  
  
export const EblDetailSlice = createSlice({
    name: 'eblDetails',
    initialState,
    reducers: {

    },
    extraReducers: (builder) => {
        builder.addCase(getEBLDetails.pending, (state, action) => {
            state.isEBLDetailsLoading = true;
        });
        builder.addCase(getEBLDetails.fulfilled, (state, action) => {
            state.isEBLDetailsLoading = false;
            state.eblData = action.payload;
            const roleList = action.payload.roleList || [];

            // Initialize with null if role is not found
            state.shipper = roleList.find((role:RoleList) => role.roleName === 'shipper')?.partyName || null;
            state.titleHolder = roleList.find((role:RoleList) => role.roleName === 'titleOwner')?.partyName || null;
            state.consignee = roleList.find((role:RoleList) => role.roleName === 'consignee')?.partyName || null;
            state.custodian = roleList.find((role:RoleList) => role.roleName === 'blHolder')?.partyName || null;
        });

        builder.addCase(getEBLDetails.rejected, (state, action) => {
            state.isEBLDetailsLoading = false;
            state.eblData = null;
            state.shipper = null;
            state.titleHolder = null;
            state.consignee = null;
            state.custodian = null;
        });

        builder.addCase(getPartyNameList.pending, (state) => {
            state.isEBLDetailsLoading = true;
            
          });
          builder.addCase(getPartyNameList.fulfilled, (state, action) => {
            state.isEBLDetailsLoading = false;
            state.partyNames = action.payload; 

          });
          builder.addCase(getPartyNameList.rejected, (state, action) => {
            state.isEBLDetailsLoading = false;
            state.partyNames = null;
            
          });

          builder.addCase(getBankNameList.pending, (state) => {
            state.isEBLDetailsLoading = true;
            
          });
          builder.addCase(getBankNameList.fulfilled, (state, action) => {
            state.isEBLDetailsLoading = false;
            state.bankNames = action.payload; 

          });
          builder.addCase(getBankNameList.rejected, (state, action) => {
            state.isEBLDetailsLoading = false;
            state.bankNames = null;
            
          });

    }
});

export const {

} = EblDetailSlice.actions;

export default EblDetailSlice.reducer;
